import { Target, BookOpen, Calculator, MessageCircle, TrendingUp, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import Reveal from "./Reveal";

const Features = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Target, titleKey: "features.1.title", descKey: "features.1.desc", span: "lg:col-span-2", accent: "violet" },
    { icon: BookOpen, titleKey: "features.2.title", descKey: "features.2.desc", span: "", accent: "violet" },
    { icon: Calculator, titleKey: "features.3.title", descKey: "features.3.desc", span: "", accent: "violet" },
    { icon: MessageCircle, titleKey: "features.4.title", descKey: "features.4.desc", span: "lg:col-span-2", accent: "coral" },
    { icon: TrendingUp, titleKey: "features.5.title", descKey: "features.5.desc", span: "", accent: "violet" },
    { icon: MapPin, titleKey: "features.6.title", descKey: "features.6.desc", span: "", accent: "violet" },
  ];

  return (
    <section className="py-24 bg-ink-800">
      <div className="container mx-auto px-6">
        <Reveal className="text-center mb-16 max-w-2xl mx-auto">
          <div className="eyebrow mb-4">{t("eyebrow.features")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-white mb-4">{t("features.title")}</h2>
          <p className="text-lg text-white/65">{t("features.sub")}</p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const isCoral = feature.accent === "coral";
            const isWide = feature.span !== "";
            return (
              <Reveal
                key={index}
                as="article"
                delay={index * 70}
                className={`${feature.span} group`}
              >
                <div className={`h-full bg-ink-700 border border-white/[0.06] p-7 rounded-[28px] transition-all duration-300 hover:-translate-y-1 ${isCoral ? "hover:border-coral/45" : "hover:border-violet/45"} group-hover:rotate-[-0.4deg]`}>
                  <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-5 ${isCoral ? "bg-coral/15" : "bg-violet/15"}`}>
                    <feature.icon className={`h-5 w-5 ${isCoral ? "text-coral" : "text-violet"}`} />
                  </div>
                  <h3 className={`font-display text-white mb-2 ${isWide ? "text-3xl" : "text-2xl"}`}>
                    {t(feature.titleKey)}
                  </h3>
                  <p className={`text-white/65 leading-relaxed ${isWide ? "text-[15px] max-w-md" : "text-sm"}`}>
                    {t(feature.descKey)}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
